(function () {
	'use strict';
	$(document).ready(function () {
		const $header = $('header');
		const $menuTopBar = $('.top-bar-menu')
		const $menuOverlay = $('.menu-overlay');
		let lastWindowWidth = $(window).width();

		// Menu toggle
		$(".menu-toggle").on('click', function () {
			if ($header.hasClass('open')) {
				$('body').css('overflow', 'unset')
			} else {
				$('body').css('overflow', 'hidden')
			}
			$menuOverlay.fadeToggle(300);
			$menuOverlay.toggleClass('open');
			$(this).toggleClass("open");
			$header.toggleClass('open');
			closeSubmenus();
		});

	$('ul.header-main-menu li.menu-item-has-children > a, ul.footer-main-menu li.menu-item-has-children > a').on('click', function (e) {
		e.preventDefault();
		e.stopPropagation();
		const $this = $(this);
			if ($this.hasClass('active')) {
				$this.siblings('.submenu').stop().slideUp(300);
				$this.parent().removeClass('open');
				$this.removeClass('active');
			} else {
				$this.siblings('.submenu').stop().slideToggle(300);
				$this.parent().toggleClass('open');
				$this.toggleClass('active');
			}
		});

		$('ul.top-bar-menu li.menu-item-has-children > a').on('click', function (e) {
			e.preventDefault();
			const $this = $(this);
			if ($this.hasClass('active')) {
				$this.siblings('.submenu').stop().slideUp(300);
				$this.parent().removeClass('open');
				$this.removeClass('active');
			} else {
				$this.siblings('.submenu').stop().slideToggle(300);
				$this.parent().toggleClass('open');
				$this.toggleClass('active');
			}
		});
		clickedOutside('ul.top-bar-menu li.menu-item-has-children > .submenu', function (target) {
			target.stop().slideUp(300);
			target.parent().removeClass('open');
			target.siblings('a').removeClass('active');
		}, ['ul.top-bar-menu li.menu-item-has-children'])

		clickedOutside('.menu-overlay', closeMenu, ['.menu-toggle']);

		$(window).resize(function () {
			if ($(window).width() !== lastWindowWidth) {
				closeMenu();
				lastWindowWidth = $(window).width();
			}
		});

		function closeMenu() {
			$('.header-right nav.open').fadeOut(300, function () {
				$(this).css('display', '');
				$(this).removeClass('open');
			});
			$header.removeClass('open');
			$('.menu-toggle').removeClass('open');
			$menuOverlay.fadeOut();
			$menuOverlay.removeClass('open');
			closeSubmenus();
		}

		function closeSubmenus(dataLevel = 1) {
			$('ul[data-level="' + dataLevel + '"] li.menu-item-has-children > a.active').each(function () {
				$(this).siblings('.submenu').stop().slideToggle(300, function () {
					$(this).css('display', '')
				});
				$(this).removeClass('active');
				$(this).parent().removeClass('open');
			});
		}

	});
}(jQuery));